export default __webpack_public_path__ + "static/media/cluster_point_turquoise.59382e24.svg";